import type { FC } from 'react';
import type { BoxProps } from '@mui/material';
import { Box, Tooltip, Typography, useTheme } from '@mui/material';

export interface ComparisonPillProps extends BoxProps {
  value: number | string;
  mouseOverValue?: number | string;
}

const ComparisonPill: FC<ComparisonPillProps> = ({
  value,
  mouseOverValue,
  ...boxProps
}) => {
  const { colors } = useTheme();
  return (
    <Box
      {...boxProps}
      sx={[
        {
          bgcolor: colors.comparison[400],
          px: 0.5,
          py: 0.25,
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          width: 'auto',
          fontSize: 'initial',
        },
        ...(Array.isArray(boxProps.sx) ? boxProps.sx : [boxProps.sx]),
      ]}
    >
      <Tooltip title={mouseOverValue}>
        <Typography variant="caption" color="white">
          {value}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default ComparisonPill;
